// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_14G3-","description":"ShwsE"};